import React, { PureComponent } from "react";
import { BetQLSportItem, NameKeyPair } from "src/common-services";

import styles from "./styles.scss";
import ButtonGroup, { ButtonGroupItem } from "../../../ButtonGroup";
import { renderRatingByValue } from "../../../../services/ValueDataService";
import { SubscriptionContext } from "../../../../services/SubscriptionService";

/**
 * State representation of trending summary
 */
interface State {
  homeTeamSelected: boolean;
}

/**
 * Trends summary data representation
 */
interface TrendSummaryData {
  title: string;
  display: JSX.Element;
  containerStyle?: string;
  titleStyle?: string;
  dataStyle?: string;
}

/**
 * Data passed onto the trending summary
 */
interface Props {
  freeGame: boolean;
  onTeamSelected: (teamId: string) => void;
  homeTeam: any;
  awayTeam: any;
  homeTeamSelected: boolean;
  currentSportObj: BetQLSportItem;
  currentTrendType: NameKeyPair;
  trends: Array<any>;
}

/**
 * Trending summary provides overview of trending data in a concise manner.
 */
class TrendingSummary extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { homeTeamSelected: props.homeTeamSelected };
  }

  /**
   * Build the summary data, avg star, record, units won, and ROI
   */
  _buildSummaryData = () => {
    const { trends } = this.props;
    const totalTrends: number = trends.length;

    let totalRating: number = 0;
    let wins: number = 0;
    let losses: number = 0;

    for (let i = 0; i < trends.length; i++) {
      totalRating += Math.abs(trends[i].rating);

      if (trends[i].rating > 0) {
        losses += trends[i].losses;
        wins += trends[i].wins;
      } else {
        losses += trends[i].wins;
        wins += trends[i].losses;
      }
    }

    const dataList: Array<TrendSummaryData> = [
      {
        title: "Avg Stars",
        display: <span>{renderRatingByValue(totalRating / totalTrends)}</span>,
        containerStyle: "trending-summary__avg-rating-row",
        titleStyle: "trending-summary__avg-rating-title trending-summary__stat-title",
        dataStyle: "trending-summary__avg-rating-data",
      },
      {
        title: "Record",
        display: (
          <span>
            {wins}-{losses}
          </span>
        ),
      },
    ];

    return dataList;
  };

  /**
   * Renders list of stats for given home/away team. Lists all of the important data such as wins/losses. This list is expected
   * to grow and needs to be able to rendered in vertical as well as horizonal method to support mobile/tablet/desktop
   *
   * @param homeTeamStats The home team stat that was delivered via graphql
   * @param awayTeamStats The away team stat that was delivered via graphql
   *
   */
  renderSummaryList = () => {
    return (
      <React.Fragment>
        {this._buildSummaryData().map((item: TrendSummaryData, index: number) => (
          <div className={item.containerStyle ? item.containerStyle : "trending-summary__row"} key={index}>
            <div className={item.titleStyle ? item.titleStyle : "trending-summary__stat-title"}>
              <span>{item.title}</span>
            </div>
            <div className={item.dataStyle ? item.dataStyle : "trending-summary__stat-data"}>{item.display}</div>
          </div>
        ))}
      </React.Fragment>
    );
  };

  /**
   * Select home/away team
   *
   * @param item Which button group home/away
   * @param index The button index
   */
  onSelectHomeAway = (item: ButtonGroupItem, index: number) => {
    this.setState({ homeTeamSelected: index === 1 });
    this.props.onTeamSelected(item.key);
  };

  /**
   * Create buttom groups to select away/home teams
   *
   * @param awayTeam Away team parameter from event object
   * @param homeTeam Home team parameter from event object
   */
  _renderTeamButtonGroup = (awayTeam: any, homeTeam: any) => {
    const teamsGroupItems: ButtonGroupItem[] = [
      {
        name:
          this.props.currentSportObj.key === "CFB" || this.props.currentSportObj.key === "CBK"
            ? awayTeam.preferredAbbreviation
            : awayTeam.lastName,
        key: awayTeam.id,
      },
      {
        name:
          this.props.currentSportObj.key === "CFB" || this.props.currentSportObj.key === "CBK"
            ? homeTeam.preferredAbbreviation
            : homeTeam.lastName,
        key: homeTeam.id,
      },
    ];

    return (
      <ButtonGroup
        selectedButtonStyle="trending-summary__button trending-summary__button--selected"
        unselectedButtonStyle="trending-summary__button trending-summary__button--deselected"
        equalWidth={true}
        className="trending-summary__button-group"
        onSelectItem={this.onSelectHomeAway}
        selectedIndex={this.state.homeTeamSelected ? 1 : 0}
        items={teamsGroupItems}
      />
    );
  };

  render() {
    const { freeGame, homeTeam, awayTeam, currentSportObj } = this.props;
    const { homeTeamSelected } = this.state;
    const currentTeam = homeTeamSelected ? homeTeam : awayTeam;

    return (
      <SubscriptionContext.Consumer>
        {({ hasSubscriptionAccess }) => {
          const hasAccess = hasSubscriptionAccess(currentSportObj.key);
          return (
            <div className="trending-summary__container">
              <div className="trending-summary__team-button-container">
                {this._renderTeamButtonGroup(this.props.awayTeam, this.props.homeTeam)}
              </div>
              <div className="trending-summary__table-container">
                <div className="trending-summary__title">Top Trends Summary</div>
                {this.props.trends.length > 0 ? (
                  <React.Fragment>
                    {/*<div className="trending-summary__description">
                      The {currentTeam.lastName}'s top {this.props.trends.length}{" "}
                      {this.props.trends.length > 1 ? "trends " : "trend "}
                      favoring them to cover the {this.props.currentTrendType.name}
                    </div>*/}
                    {freeGame || hasAccess ? (
                      <div className="trending-summary__data">{this.renderSummaryList()}</div>
                    ) : null}
                  </React.Fragment>
                ) : (
                  <div className="trending-summary__description">
                    No {this.props.currentTrendType.name} trend for {currentTeam.lastName} currently
                  </div>
                )}
              </div>
              <style jsx global>
                {styles}
              </style>
            </div>
          );
        }}
      </SubscriptionContext.Consumer>
    );
  }
}

export default TrendingSummary;
